/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller.js                                                                   */
/**********************************************************************************************************************/
/* Controller */
HafasWebapp.prototype.Controller = {
  /**
   * @class this.Controller.App
   */
  App:{
    switchContext: function(data) {
      // e.g. for DOM or js-cleanup
      Hafas.ps.pub('/app/beforeSwitchContext', [data]);

      // data kann leer sein, wenn kein applicationcontext ueber History gesetzt ist.
      // wenn das der Fall ist wird der Startcontext genommen
      if (!data) {
        data = {};
        data.context = Hafas.Config.startingAppContext;
        data.method = 'index';
      }

      // Fire event for leaving context
      if(data.context !== this.appContext && !data.dontLeaveContext){
        Hafas.ps.pub('/GUI/leaveContext/' + this.appContext);
      }

      // change this.appContext
      this.prevContext = this.appContext;
      this.appContext = data.context;

      // if no method is set, use 'index'
      data.method = data.method || 'index';

      if (typeof this.Controller[data.context] === 'undefined')
      {
        data.context = 'TP'
      }
      Hafas.bind(this.Controller[data.context][data.method],this)();

      Hafas.ps.pub('/GUI/common/setApplicationHeader', [{appcontext: data.context}]);
      Hafas.ps.pub('/app/events/resize');

      if(Hafas.Config.initAnalysisMode) {
        Hafas.ps.pub('/analysis/init');
      }

      // Tracking
      // Hier muss für das tracking wieder einer Unterscheidung nach AppContext gemacht werden.
      // data.trigger kommt aus den menübuttons und ist somit der Indikator für das Tracking
      if (typeof data !== 'undefined' && typeof data.trigger !== 'undefined' && typeof data.context !== 'undefined') {
        switch (data.context) {
          case 'TP':
            Hafas.ps.pub('/tracking/event/menu-journey-planner', [{typ: 'event', key: 'menu-journey-planner'}]);
            Hafas.ps.pub('/tracking/event/menu-item-pressed', [{
              typ: 'event',
              key: 'menu-item-pressed',
              data: {type: 'tripplanner'}
            }]);
            break;
          case 'SQ':
            Hafas.ps.pub('/tracking/event/menu-stationboard-planner', [{
              typ: 'event',
              key: 'menu-stationboard-planner'
            }]);
            Hafas.ps.pub('/tracking/event/menu-item-pressed', [{
              typ: 'event',
              key: 'menu-item-pressed',
              data: {type: 'stationboard'}
            }]);
            break;
          case 'Imprint':
            Hafas.ps.pub('/tracking/event/imprint', [{typ: 'event', key: 'imprint'}]);
            Hafas.ps.pub('/tracking/event/menu-item-pressed', [{
              typ: 'event',
              key: 'menu-item-pressed',
              data: {type: 'info'}
            }]);
            break;
        }
      }

      if(Hafas.Modules.IFrameApi)
      {
        Hafas.Modules.IFrameApi.sendSwitchContext(data.context);
      }

      // scroll_to_top
      var scrollBack = document.getElementById("HFS_TpScrollBack");
      window.onscroll = function() {
        if (document.body.scrollTop > 260 || document.documentElement.scrollTop > 260) {
          scrollBack.style.display = "block";
        } else {
          scrollBack.style.display = "none";
        }
      };
    },
    switchLanguage: function(data) {
      if (data.ev) data.ev.preventDefault();

      // change hciLanguage in Hafas.Config
      var availableLanguages = Hafas.Config.languages;
      var i = 0,
          iLen = availableLanguages.length,
          currentLangObject = null;
      for ( i ; i < iLen ; i++ ) {
        if (data.lang === availableLanguages[i].lang) {
          currentLangObject = availableLanguages[i];
        }
      }

      // language Storage läuft nach einem Tag aus
      currentLangObject.expires = new Date().getTime() + 1000*60*60*24;

      localStorage.setItem(Hafas.Config.storageId + 'lang', JSON.stringify(currentLangObject));

      // Get SubPath, wenn im Mandanten /Whitelabelkontext
      var _customerPath = '';
      if (typeof Hafas.Config.isCustomer != 'undefined' && Hafas.Config.isCustomer === true) {
        _customerPath = '&L=' + Hafas.Util.getUrlParams('L') + '&';
      }


      Hafas.Config.defaultLang = currentLangObject.lang;
      Hafas.Config.hciLang = currentLangObject.hciLang;

      var baseURL = window.location.origin;
      var path = window.location.pathname;
      var search = '?language=' + Hafas.Config.defaultLang + _customerPath;
      var hash = window.location.hash;

      window.location.href = baseURL + path + search + hash;
    },
    triggerLoadingImage: function(trigger){
      /*this.trigger = trigger;
      this.triggerLoadingImage = new Image();
      this.triggerLoadingImage.src = Hafas.Config.loadingImage;
      this.triggerLoadingImage.width = '14px';
      this.triggerLoadingImage.height = '14px';
      this.trigger.setAttribute('disabled', 'disabled');
      this.trigger.appendChild(this.triggerLoadingImage);*/
    },
    events: {
      closeResults: function(data) {
        if(typeof data.ev != 'undefined'){
          data.ev.preventDefault();
        }

        var keepOverviewScrollPos = false;

        if (data && data.resultSet === 'detail') {
          keepOverviewScrollPos = true;
        }

        Hafas.ps.pub('/GUI/results/details/hide', [{}]);
        Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
        Hafas.ps.pub('/GUI/results/all/hide', [{}]);


        Hafas.ps.pub('/GUI/results/overview/removeActive', [{arrayIdx: null}]);
        Hafas.ps.pub('/GUI/results/additional/hideAll');
        Hafas.ps.pub('/GUI/results/resize', [{container: this.resultOverviewContainer, appcontext: this.appContext}]);
      }
    }
  },
  /**
   * @class this.Controller.Common
   */
  Common: {
    openExternalLink: function(url) {
      window.open(url, "_blank");
    },
    Observe: {
      Inputs: function (method, input_id, values) {
        var _result = null;
        switch (method) {
          case "set":
            var _vals = values;
            _vals.ts = new Date().getTime();
            localStorage.setItem(input_id, JSON.stringify(_vals));
            break;
          case "get":
            if (localStorage.getItem(input_id)) {
              var _storeData = JSON.parse(localStorage.getItem(input_id));
              var _now = new Date().getTime();
              if ( (_now - _storeData.ts) < 120000) {
                _result = _storeData.val;
              }
              else {
                localStorage.removeItem(input_id);
              }
            }
            break;
        }
        return _result;
      }
    },
    /**
     * @class this.Controller.Common.Time
     */
    Time: {
      DatePicker: {
        consoleClr: 'background-color: #ea0; color: #000;',
        open: function(dateTimePickerInstance) {
          var _dateTimePickerInstance = Hafas.Modules.TimeDatePicker.getInstanceById(params.pickerId);
          _dateTimePickerInstance.show();
        },

        confirm: function(params) {
          if (Hafas.Config.debug.showDataModel) {
            console.log('%c+++ this.Controller.Common.Time.DatePicker.confirm(tdpinstance)', this.Controller.Common.Time.DatePicker.consoleClr);
          }
          var _dateTimePickerInstance = Hafas.Modules.TimeDatePicker.getInstanceById(params.pickerId);
          _dateTimePickerInstance.confirm();
          Hafas.ps.pub('/tracking/event/datetimepicker-changed',[ { typ: 'event', key: 'datetimepicker-changed', data: {type: 'accepted'} } ]);

        },
        cancel: function(params) {
          if (Hafas.Config.debug.showDataModel) {
            console.log('%c+++ this.Controller.Common.Time.DatePicker.cancel(tdpinstance)', this.Controller.Common.Time.DatePicker.consoleClr);
          }
          var _dateTimePickerInstance = Hafas.Modules.TimeDatePicker.getInstanceById(params.pickerId);
          _dateTimePickerInstance.cancel();
          Hafas.ps.pub('/tracking/event/datetimepicker-changed',[ { typ: 'event', key: 'datetimepicker-changed', data: {type: 'cancelled'} } ]);
        },
        setData: function (params) {
          var _dateTimePickerInstance = Hafas.Modules.TimeDatePicker.getInstanceById(params.pickerId);
          if(params.time)
            _dateTimePickerInstance.setTime(params.time);
          if(params.date)
            _dateTimePickerInstance.setDate(params.date);
          if(params.enquiry)
            _dateTimePickerInstance.setEnquiry(params.enquiry);
          if(params.timeNow)
            _dateTimePickerInstance.setTimeNow(params.timeNow)
        },
        onChangeNativeInput: function(params) {
          var _dateTimePickerInstance = Hafas.Modules.TimeDatePicker.getInstanceById(params.pickerId);
          _dateTimePickerInstance.readNativeFields(params);
        }
      }
    }
  },
  /**
   * @class this.Controller.APIs
   */
  APIs: {
    /**
     * @class this.Controller.APIs.Geolocation
     */
    Geolocation: {
      check: function() {

        if (typeof Hafas.Config.Switches.checkGeoLocationOnInit != 'undefined' && Hafas.Config.Switches.checkGeoLocationOnInit !== true){
          return;
        }


        if (typeof Hafas.Config.Switches.useGetGeoLocation != 'undefined' && Hafas.Config.Switches.useGetGeoLocation === true) {
          Hafas.Util.geo.supportsGeoLocation(function(hasSupport) {
            var $icon = Hafas('#HFS_GetActualPosition', false);
            if(!hasSupport && $icon) {
              console.log('getActualposition wird nicht unterstützt');
              $icon.setAttribute('disabled', 'disabled');
              $icon.setAttribute('aria-hidden', true);
              $icon.addClassName('hfs_currentPositionDisabled');
            }
          });
        }
        else if (typeof Hafas.Config.Switches.useGetGeoLocation != 'undefined' && Hafas.Config.Switches.useGetGeoLocation === false) {

          // Das Suggest verwendet ebenfalls die Geolocation.
          // Muss auf "false" gesetzt werden, wenn Geolocation global schon nicht verwendet
          // werden soll.
          // VORSICHT: Die config-Parameter können schönen beim Instanzieren anders gesetzt sein!
          //           Diese Überprüfung erfolgt dann im Suggest-Modul in Abhängigkeit mit den Daten
          //           aus dem Hafas.Config.HTML5.APIs-Objekt
          Hafas.Config.Suggest.useActualPosition = false;
          Hafas.Config.Suggest.useNearLocation = false;

          Hafas.Config.HTML5.APIs.Geolocation.CanIUse = false;
          Hafas.Config.HTML5.APIs.Geolocation.Status = 'Geolocation not configured';

          // Der Errorcode '99' ist ausgedacht!
          // Er dient für die entsprechende Template-Ausgabe als Flag
          Hafas.Config.HTML5.APIs.Geolocation.ErrorCode = 99;

          var $icon = Hafas('#HFS_GetActualPosition', false);
          if($icon) {
          $icon.setAttribute('aria-hidden', true);
          $icon.setAttribute('hidden', 'hidden');
          $icon.addClassName('hidden');
        }
      }
    }
    }
  },
  Favorites:{

  },
  Forms: {
    reset: function(opts) {
      switch (opts.appContext) {
        case 'TP':
          if (opts.form === 'index') {
            var $from = this.Controller.TP.inpFrom.inp;
            var $to = this.Controller.TP.inpTo.inp;

            $from.value = '';
            $to.value = '';
            // Todo: reset Calendar and Time data
            // Todo: reset Options

            // Reinit für Calender
            Hafas.Core.init();
          }
          break;
      }
    }
  },
  /**
   * @class this.Controller.Exceptions
   */
  Exceptions: {
    TQ: {
      getRoute: function(err) {
        var _me = this;
        Hafas.Core.newType("HafasOverlay", {
          app: _me,
          outputHTML: '<h1>' + err.requestId + ': ' + err.requestMethod + ' | ' + err.err + '</h1><p>' + err.errTxt + '</p>',
          cssClass: 'hfs_overlayExample',
          onClose: function() {
            console.log('Overlay closed')
          },
          callback: function(html, err) {
            if (err) console.error(err);

          }
        });
      },
      drawHighlightedSection: function(err) {
        var _me = this;
        Hafas.Core.newType("HafasOverlay", {
          app: _me,
          outputHTML: '<h1>' + err.requestId + ': ' + err.requestMethod + ' | ' + err.err + '</h1><p>' + err.errTxt + '</p>',
          cssClass: 'hfs_overlayExample',
          onClose: function() {
            console.log('Overlay closed')
          },
          callback: function(html, err) {
            if (err) console.error(err);

          }
        });
      }
    }
  }
};
